import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M16 14.548s-3.776-5.578-5.25-4.379c-1.472 1.2-.857 2.185.75 3.831s2.5 3.988 3.5 3c1.553-1.534-2.482-2.619-1.946 1.342.428 3.18 2.517 2.62 2.517 2.62M15.7 8.89c.13.052 2.846 3.447 2.95 3.833.103.386-.026 7.82-.026 7.82"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M11.5 20.414H7.449A1.44 1.44 0 0 1 6 18.974V5.44C6 4.643 6.647 4 7.449 4H14.2c.802 0 1.449.643 1.449 1.44V9.5"
    />
  </svg>
);
export const PhoneIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
